import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/attentionBlack.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "frame" }
const _hoisted_3 = { class: "frame__inner" }
const _hoisted_4 = { class: "frame__header" }
const _hoisted_5 = { class: "frame__body" }
const _hoisted_6 = { class: "card-remittances" }
const _hoisted_7 = { class: "card-remittances__inner" }
const _hoisted_8 = { class: "card-remittances__info" }
const _hoisted_9 = { class: "card-remittances__form" }
const _hoisted_10 = {
  id: "iframe",
  ref: "iframe",
  class: "card-remittances__iframe"
}
const _hoisted_11 = { class: "card-remittamces__btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Back = _resolveComponent("Back")!
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Back, {
            redirect: _ctx.redirect,
            title: "На банковскую карту"
          }, null, 8, ["redirect"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"card-remittances-warning card-remittances__warning\" data-v-3a33ef4a><div class=\"card-remittances-warning__inner\" data-v-3a33ef4a><div class=\"card-remittances-warning__icon\" data-v-3a33ef4a><img src=\"" + _imports_0 + "\" alt=\"icon\" data-v-3a33ef4a></div><div class=\"card-remittances-warning__text\" data-v-3a33ef4a> Cредства, списанные с баланса, будут возвращены <span data-v-3a33ef4a>в течение 30 минут</span>, если вы не укажете номер карты. </div></div></div>", 1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "card-remittances__info-label label" }, "Откуда:", -1)),
                _createElementVNode("span", null, "+7 " + _toDisplayString(_ctx.paymentInfo.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, null, 512)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_ap_button, {
                  type: "primary",
                  full: "",
                  onClick: _ctx.goMain
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Вернуться на главную ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}